import * as React from "react"

export const ChevronRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.946 12 8.873 7.927a.73.73 0 0 1-.213-.522.7.7 0 0 1 .213-.532.72.72 0 0 1 .527-.217q.31 0 .527.217l4.494 4.494a.83.83 0 0 1 .256.633.832.832 0 0 1-.256.633l-4.494 4.494a.73.73 0 0 1-.523.213.7.7 0 0 1-.531-.213.72.72 0 0 1-.218-.527q0-.31.218-.527z"
    ></path>
  </svg>
)
